import React from 'react';

import { FormField } from '../form-field';
import TextField from '../text-field';
import ImageAvatar from 'ui/image/image-avatar';

import { isValue } from 'ui/form/utils';
import { debounce } from 'helpers/decorators';
import { REQUIRED } from 'ui/form/constants';
import { VimeoFieldProps } from 'ui/form/fields';

interface VimeoFieldState {}

function getVimeoURL(videoId) {
  return 'https://vimeo.com/' + videoId;
}
export default class VimeoField extends FormField<VimeoFieldProps, VimeoFieldState> {
  static getErrors(props: VimeoFieldProps, formData) {
    const value = isValue(props.value) ? props.value : (formData || {})[props.name];
    
    if (props.required && !(value && value.id)) return REQUIRED;
    else if (!value || !value.id) return 'Invalid Vimeo URL';
    
    return false;
  }
  
  state = {
    errors: false
  };

  validate() {
    let errors = VimeoField.getErrors(this.props);
    this.setState({ errors });
    
    return !errors;
  }

  handleChange = change => {
    if (this.props.onChange) this.handleUrlSubmit(change);
  };

  @debounce(400)
  async handleUrlSubmit(url) {
    if (url) {
      try {
        let res = await fetch('https://vimeo.com/api/oembed.json?url=' + url);
        res = await res.json();
        if (res.video_id) {
          this.props.onChange({
            id: res.video_id,
            thumbnail: res.thumbnail_url,
            title: res.title,
            duration: res.duration,
            desc: res.description
          });
          this.setState({ errors: false });
        } else {
          this.setState({ errors: 'Invalid link' });
          this.props.onChange();
        }
      } catch (e) {
        this.setState({ errors: 'Invalid link' });
        this.props.onChange();
      }
    }
  }
  render() {
    const { onChange, value, ...rest } = this.props;
    const { errors } = this.state;
    const thumbNail = value && value.thumbnail;

    return (
      <div>
        <TextField
          {...rest}
          leftComponent={thumbNail && <ImageAvatar image={thumbNail} small />}
          value={value && value.id && getVimeoURL(value.id)}
          error={errors}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}
